import React, { FC, ReactNode } from 'react'

import { t } from 'translations'
import { Card, Spinner } from 'ui'

type Props = {
  body?: JSX.Element
  className?: string
  title?: string
  titleVar?: Record<string, unknown>
  titleIcon?: string
  classNameBody?: string
  classNameHeader?: string
  isLoading?: boolean
  titleChildren?: React.Component[]
  titleLink?: JSX.Element
  children?: ReactNode
}

const MerinioCard: FC<Props> = ({
  body,
  children,
  title,
  titleChildren,
  titleLink,
  titleVar = {},
  titleIcon,
  className = 'mb-2',
  classNameBody = 'p-3',
  classNameHeader,
  isLoading
}) => {
  const summaryKey = `${title}.SUMMARY`
  const summaryTranslation = t(summaryKey)

  return (
    <Card className={`${className}`}>
      {/* If there is no title, don't render the card header */}
      {title ? (
        <>
          <Card.Header className="p-2 pl-3">
            {titleLink ? (
              <div className="d-flex mb-2">
                <span className="ml-auto">{titleLink}</span>
              </div>
            ) : null}
            <div>
              <Card.Title className={`mb-0 ${classNameHeader}`}>
                <>
                  {titleIcon ? <i className={`fad fa-${titleIcon} mr-2`}></i> : null}
                  {t(`${title}.TITLE`, titleVar)}
                  {titleChildren}
                </>
              </Card.Title>
              {summaryTranslation && summaryTranslation !== summaryKey ? (
                <Card.Subtitle className="my-2 text-muted">{t(`${title}.SUMMARY`)}</Card.Subtitle>
              ) : null}
            </div>
          </Card.Header>
        </>
      ) : null}
      {/* Shows a spinner if the card is loading */}
      {isLoading ? (
        <Card.Body className="p-1 text-center">
          <Spinner size="lg" />
        </Card.Body>
      ) : (
        <div>
          {body ? <Card.Body className={`p-1 ${classNameBody}`}>{body}</Card.Body> : null}
          {children}
        </div>
      )}
    </Card>
  )
}

export default MerinioCard
